module.exports = __webpack_public_path__ + "img/service-sec01-img01.6da50a4d.png";